import PropTypes from 'prop-types';
import cn from 'classnames';

function LdsLinkList({
  className,
  children,
  ...rest
}) {
  return (
    <ul
      className={cn(
        'lds-link-list',
        className
      )}
      {...rest}
    >
      {children}
    </ul>
  );
}

LdsLinkList.Item = function LdsLinkListItem({
  className,
  children,
  ...rest
}) {
  return (
    <li
      className={cn(
        'lds-link-list-item',
        className
      )}
      {...rest}
    >
      {children}
    </li>
  );
};

LdsLinkList.Subheader = function LdsLinkListSubheader({
  id,
  className,
  children,
  ...rest
}) {
  let idVal = id;

  if (!id) {
    idVal = `${children.toLowerCase().replace(/ /g, '-')}-${Math.floor(
      Math.random() * 10000
    )}`;
  }

  return (
    <li
      className={cn(
        'lds-link-list-subheader-item',
        className
      )}
      aria-describedby={idVal}
      {...rest}
    >
      <span
        id={idVal}
        className="lds-link-list-subheader"
      >
        {children}
      </span>
    </li>
  );
};

// Prop Types
LdsLinkList.propTypes = {
  children: PropTypes.node,
};
LdsLinkList.Item.propTypes = {
  children: PropTypes.node,
};
LdsLinkList.Subheader.propTypes = {
  children: PropTypes.node,
};

export default LdsLinkList;
